import React, { Component } from "react";
import { NavLink as RouteLink } from "react-router-dom";
import $ from "jquery";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import "../../vendor/hamburgers/hamburgers.min.css";
import "./Navbar.css";

import LogoImg from "../../assets/images/Corviva_svg.svg";

var Scroll = require("react-scroll");

var Link = Scroll.Link;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affix: false,
      navbarCollapsed: false,
      currentRoute: ""
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("click", this.handleOutsideClick);
    scrollSpy.update();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("click", this.handleOutsideClick);
  }

  // Scrolling
  handleScroll() {
    this.updateAffix();
  }

  updateAffix() {
    let offset;
    this.state.currentRoute === "/" ? (offset = 350.0) : (offset = 200.0);
    let affixValue = window.pageYOffset || document.body.scrollTopp > offset;
    this.setState({ affix: affixValue });
  }

  checkCurrentRoute(event, pathName, gaName) {
    if (window.location.pathname !== pathName) {
      this.props.click_function("Navbar", gaName);
    } else {
      event.preventDefault();
    }
  }

  toggleNavbar() {
    if (this.isMobile()) {
      $(".navbar-collapse ").toggle("in");
      if (this.state.navbarCollapsed === false) {
        this.setState({ navbarCollapsed: true });
        $(".hamburger ").addClass("is-active");
      } else {
        this.setState({ navbarCollapsed: false });
        $(".hamburger ").removeClass("is-active");
      }
    }
  }

  handleOutsideClick(event) {
    if (
      !this.node.contains(event.target) &&
      this.state.navbarCollapsed === true &&
      this.isMobile()
    ) {
      this.toggleNavbar();
    }
  }

  isMobile() {
    return window.innerWidth <= 991;
  }

  // Rendering
  render() {
    let navbarClasses = classNames({
      navbar: true,
      "container-fluid": true,
      "navbar-toggleable-md": true,
      "navbar-custom": true,
      "navbar-default": true,
      "fixed-top": true,
      "affix-top": !this.state.affix,
      affix: this.state.affix
    });
    return (
      <nav
        id="main-nav"
        className={navbarClasses}
        ref={node => {
          this.node = node;
        }}
      >
        <div className="navbar-header">
          <button
            onClick={() => this.toggleNavbar()}
            className="navbar-toggler pull-right hamburger hamburger--collapse  collapsed"
            type="button"
            data-toggle="collapse"
            data-target="#navbar-collapse"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
          <RouteLink
            onClick={e => {
              if (window.location.pathname === "/") {
                e.preventDefault();
                scroll.scrollToTop({
                  spy: true,
                  smooth: true,
                  duration: 500
                });
                if (this.state.navbarCollapsed === true) {
                  this.toggleNavbar();
                } else {
                  void 0;
                }
              } else {
                this.checkCurrentRoute(e, "/", "Home");
                if (this.state.navbarCollapsed === true) {
                  this.toggleNavbar();
                } else {
                  void 0;
                }
              }
            }}
            exact
            to="/"
          >
            <div className="nav-iconMargin pull-left">
              <img className="nav-icon" src={LogoImg} alt="App Shack icon" />
            </div>
          </RouteLink>
        </div>

        <div className="collapse navbar-collapse" id="navbar-collapse">
          <ul className="nav navbar navbar-nav ml-auto">
            <li className="hidden">
              <Link to="page-top" spy smooth duration={500} />
            </li>
            <li className="nav-item">
              <RouteLink
                className="nav-link"
                onClick={e => {
                  this.toggleNavbar();
                  scroll.scrollToTop({
                    spy: true,
                    duration: 0
                  });
                  this.checkCurrentRoute(e, "/", "Home");
                }}
                to="/"
                exact
                activeClassName="highlighted"
              >
                Hem
              </RouteLink>
            </li>
            <li className="nav-item">
              <RouteLink
                className="nav-link"
                onClick={e => {
                  this.toggleNavbar();
                  scroll.scrollToTop({
                    spy: true,
                    smooth: true,
                    duration: 0
                  });
                  this.checkCurrentRoute(e, "/services", "Services");
                }}
                to="/services"
                activeClassName="highlighted"
              >
                Tjänster
              </RouteLink>
            </li>
            <li className="nav-item lastChild">
              <RouteLink
                className="nav-link lastChildLink"
                onClick={e => {
                  this.toggleNavbar();
                  scroll.scrollToTop({
                    spy: true,
                    smooth: true,
                    duration: 0
                  });
                  this.checkCurrentRoute(e, "/contact", "Contact");
                }}
                to="/contact"
                activeClassName="highlighted"
              >
                Kontakt
              </RouteLink>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

Navbar.propTypes = {
  click_function: PropTypes.func
};
Navbar.defaultProps = {
  click_function: () => {}
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.jsx